<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M8.00084 3.42871C9.97102 3.42871 11.8605 4.21136 13.2536 5.60449C14.6468 6.99761 15.4294 8.8871 15.4294 10.8573C15.4294 11.1604 15.309 11.4511 15.0947 11.6654C14.8804 11.8797 14.5896 12.0001 14.2866 12.0001H1.71512C1.41201 12.0001 1.12133 11.8797 0.907 11.6654C0.692674 11.4511 0.572266 11.1604 0.572266 10.8573C0.572266 8.8871 1.35492 6.99761 2.74805 5.60449C4.14117 4.21136 6.03065 3.42871 8.00084 3.42871Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 3.42864V1.71436"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M0.572266 14.2856H15.4294"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
